import React from 'react'

import MfaChallenge from '../mfa-challenge'

function OAuthMfaChallenge() {
  return <MfaChallenge isOAuth={true} />
}

export default OAuthMfaChallenge
